module.exports = __webpack_public_path__ + "static/media/videoEditor-3.42c5d746.webp";